import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const add_career = createAsyncThunk(
  "career/add_career",
  async (career, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/career-add", career, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const update_career = createAsyncThunk(
  "career/updatecareer",
  async (career, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/career-update", career, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_careers = createAsyncThunk(
  "career/get_careers",
  async ({ page, parPage, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/careers-get?page=${page}&parPage=${parPage}&searchValue=${searchValue}`, {
        withCredentials: true,
      });
      console.log(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_career = createAsyncThunk(
  "career/get_career",
  async (careerId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/career-get/${careerId}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const delete_career = createAsyncThunk(
  "career/delete_career",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/career-delete/${id}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const delete_form = createAsyncThunk(
  "career/delete_form",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/delete-form/${id}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_form = createAsyncThunk(
  "career/get_form",
  async ({ page, parPage, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/get-form?page=${page}&parPage=${parPage}&searchValue=${searchValue}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_contact = createAsyncThunk(
  "career/get_contact",
  async ({ page, parPage, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/get-contact?page=${page}&parPage=${parPage}&searchValue=${searchValue}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const delete_contact = createAsyncThunk(
  "career/delete_contact",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/delete-contact/${id}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const careerReducer = createSlice({
  name: "career",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    careers: [],
    career: null,
    careerForm: null,
    contactForm: null,
    totalcareer: 0,
    totalcontact: 0,
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [add_career.pending]: (state) => {
      state.loader = true;
    },
    [add_career.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [add_career.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
    },

    [get_careers.pending]: (state) => {
      state.loader = true;
    },
    [get_careers.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [get_careers.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.careers = payload.careers;
      state.totalcareer = payload.totalcareer || 0;
    },

    [get_career.pending]: (state) => {
      state.loader = true;
    },
    [get_career.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [get_career.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.career = payload.career;
    },

    [update_career.pending]: (state) => {
      state.loader = true;
    },
    [update_career.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [update_career.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.career = payload.career;
      state.successMessage = payload.message;
    },

    [delete_career.pending]: (state) => {
      state.loader = true;
    },
    [delete_career.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [delete_career.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.careers = state.careers.filter((c) => c._id !== payload.careerId);
    },

    [get_form.pending]: (state) => {
      state.loader = true;
    },
    [get_form.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [get_form.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.totalcontact=payload.totalFormData
      state.careerForm = payload.careerForm;
    },

    [get_contact.pending]: (state) => {
      state.loader = true;
    },
    [get_contact.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [get_contact.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.contactForm = payload.contacts;
      state.totalcontact = payload.totalcontact || 0;
    },

    [delete_form.pending]: (state) => {
      state.loader = true;
    },
    [delete_form.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [delete_form.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
    },

    [delete_contact.pending]: (state) => {
      state.loader = true;
    },
    [delete_contact.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [delete_contact.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
    },
  },
});

export const { messageClear } = careerReducer.actions;
export default careerReducer.reducer;
